@use "styles" as *;

.me-modal-column {
  display: block;

  @include remove-first-and-last-child-margins;
}
